import React from "react";
import Form from "theme/components/atoms/Form/Form";
import Stack from "theme/components/atoms/Layout/Stack";
import Facet from "../Facet";
import OptionPicker from "theme/components/molecules/OptionPicker/OptionPicker";
import { useIntl, defineMessages } from "react-intl";
import PriceFilter from "theme/components/atoms/PriceFilter/PriceFilter";
import getAppearanceFromCode from "./getAppearanceFromCode";
import FormActions from "theme/components/molecules/Form/FormActions/FormActions";
import Button, { SubmitButton } from "theme/components/atoms/Button";
import useLayoutFacets from "./useLayoutFacets";

const messages = defineMessages({
  activeFilters: {
    id: "modules.Layer.LayerFacets.activeFilters",
    defaultMessage: "Active filters",
  },
  priceFilterLabel: {
    id: "modules.Layer.LayerFacets.priceFilterLabel",
    defaultMessage: "Price",
  },
});

const LayerFacets = ({
  layer,
  onSubmit,
  onCancel,
  additionalFields,
  applyOnChange = true,
}) => {
  const intl = useIntl();
  const [
    currentFacetValues,
    hasChangesForCodes,
    onSubmitHandler,
    onChangeHandler,
    onReset,
  ] = useLayoutFacets(layer, onSubmit, applyOnChange);

  const displayedDynamicFacets = layer.dynamicFacets.filter((attribute) => {
    const isFilterActive = currentFacetValues[attribute.code]?.length > 0;
    const willBeUpdatedShortly = hasChangesForCodes.includes(attribute.code);
    return (
      attribute.__typename !== "CategoryFacet" &&
      (attribute.buckets.length >= 1 || isFilterActive || willBeUpdatedShortly)
    );
  });

  return (
    <Form
      onValidSubmit={onSubmitHandler}
      onChange={(data, hasChanges) => {
        if (hasChanges) {
          onChangeHandler(data);
        }
      }}
    >
      <Stack size="2">
        {displayedDynamicFacets.length > 0 ? (
          <Stack size="2">
            {displayedDynamicFacets.map((attribute) => {
              const currentValues = currentFacetValues[attribute.code];
              const options = attribute.buckets.map((doc) => ({
                ...doc,
              }));

              return (
                options.length > 0 &&
                (options.length >= 1 ||
                  currentValues.length > 0 ||
                  hasChangesForCodes.includes(attribute.code)) && (
                  <Facet
                    key={attribute.code}
                    label={attribute.label}
                    expandedInitially={applyOnChange}
                    activeFiltersCount={currentValues?.length || 0}
                    onReset={onReset(attribute.code)}
                  >
                    <OptionPicker
                      appearance={getAppearanceFromCode(attribute.code)}
                      id={attribute.code}
                      name={attribute.code}
                      options={options}
                      attribute={attribute}
                      value={currentValues}
                    />
                  </Facet>
                )
              );
            })}
          </Stack>
        ) : null}
        <Facet
          key="price"
          expandedInitially={applyOnChange}
          activeFiltersCount={
            currentFacetValues.price.minPrice ||
            currentFacetValues.price.maxPrice
              ? 1
              : 0
          }
          onReset={onReset("price", { minPrice: null, maxPrice: null })}
          label={intl.formatMessage(messages.priceFilterLabel)}
        >
          <PriceFilter
            name="price"
            value={currentFacetValues.price}
            applyOnChange={applyOnChange}
          />
        </Facet>
        {additionalFields && additionalFields({ values: currentFacetValues })}
        {applyOnChange ? undefined : (
          <FormActions appearance="center">
            {onCancel ? <Button onClick={onCancel}>Cancel</Button> : null}
            <SubmitButton appearance="primary">Apply filters</SubmitButton>
          </FormActions>
        )}
      </Stack>
    </Form>
  );
};

export default LayerFacets;
